export default __webpack_public_path__ + "static/media/Top Image.e5579838.jpeg";